import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../../state/reducer/types.tsx';
import {
	getProjectKey,
	isProjectAdmin,
	isProjectSimplified,
} from '../../../state/selector/app-props/index.tsx';
import { getCustomerAccess } from '../../../state/selector/app-state/index.tsx';
import { CustomerAccessChannelView } from './view.tsx';

const getCustomerPermissionsSettingsLink = (projectKey: string, isSimplified: boolean) =>
	`/jira/servicedesk/projects/${projectKey}/settings${
		isSimplified ? '/channels' : ''
	}/customer-permissions`;

const mapStateToProps = (state: State) => {
	const projectKey = getProjectKey(state);
	const isSimplified = isProjectSimplified(state);
	return {
		accessType: getCustomerAccess(state),
		isAdmin: isProjectAdmin(state),
		link: getCustomerPermissionsSettingsLink(projectKey, isSimplified),
	};
};

export const CustomerAccessChannel = connect(mapStateToProps, {})(CustomerAccessChannelView);
